import { Button } from "@mui/material";
import { useState } from "react";
import "./ChangeLog.css";

function ChangeLog(props: { versions: { [key: string]: string }; canAdminProject: boolean }) {
  if (Object.keys(props.versions).length == 0) {
    return <></>;
  }

  function getVersionList() {
    if (props.canAdminProject) {
      return Object.keys(props.versions);
    }
    return Object.keys(props.versions).filter((s) => !s.startsWith("__"));
  }

  const [selectedVersion, setSelectedVersion] = useState(getVersionList()?.length - 1);
  let versionName = getVersionList()[selectedVersion];

  return (
    <div className="changelog">
      <h3 className="changelog-title">Change Log</h3>
      <div className="changelog-buttons-container">
        <Button
          variant="outlined"
          size="small"
          disabled={selectedVersion == 0}
          onClick={() => {
            setSelectedVersion((v) => v - 1);
          }}
        >
          ⬅️
        </Button>
        <Button
          variant="outlined"
          size="small"
          disabled={selectedVersion == getVersionList().length - 1}
          onClick={() => {
            setSelectedVersion((v) => v + 1);
          }}
        >
          ➡️
        </Button>
      </div>
      <span className="version-code">{versionName}</span>
      {props.versions[versionName]}
    </div>
  );
}

export default ChangeLog;
